import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=dd874ed0&scoped=true"
var script = {}
import style0 from "./Title.vue?vue&type=style&index=0&id=dd874ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd874ed0",
  null
  
)

export default component.exports